module.exports = __webpack_public_path__ + "static/media/Figtree-BoldItalic.abb29ea2.otf";